import React from 'react';
import * as Icons from 'lucide-react';
import { services, waLink } from '../mock';
import { SectionHead } from './Destinations';

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHead
          eyebrow="TRAVEL SERVICES"
          title="Everything You Need, Beyond Your Holiday."
          sub="From flights and visas to insurance and airport transfers, Travel Era Holiday takes care of every detail so you can focus on the journey."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Circle;
            return (
              <div
                key={s.title}
                className="group flex items-start gap-4 p-6 rounded-2xl border border-slate-100 bg-white reveal hover:border-[#EA5019]/30 hover:shadow-[0_16px_36px_rgba(11,37,69,0.1)] transition-all duration-300"
                style={{ transitionDelay: `${(i % 3) * 70}ms` }}
              >
                <span className="grid place-items-center h-14 w-14 shrink-0 rounded-xl bg-[#0B2545]/5 text-[#EA5019] group-hover:bg-[#EA5019] group-hover:text-white transition-colors duration-300">
                  <Icon size={26} />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-bold text-[#0B2545]">{s.title}</h3>
                  <p className="mt-1 text-sm text-slate-500 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="mt-10 text-center reveal">
          <a href={waLink} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#EA5019] text-white font-semibold hover:bg-[#cf4413] transition-colors shadow-[0_10px_26px_rgba(234,80,25,0.35)]">
            Enquire About Our Services
          </a>
        </div>
      </div>
    </section>
  );
}
